module.exports = __webpack_public_path__ + "img/lucernaire.7e71b284.jpg";